export const projects = [
  {
    title: 'BlackJack',
    folder: 'blackJack',
    genre: 'game',
    urlLive: 'https://onchetrit.github.io/blackjack/',
    urlGithub: 'https://github.com/OnChetrit/blackjack',
    mobile_image: './projects/blackjack/mobile.jpeg',
    desktop_image: './projects/blackjack/desk.jpeg',
    desc: [
      'Play Blackjack with my React.js game.',
      'Bet, hit, and stand your way to 21.',
      'Styled with Sass for a sleek and responsive design.',
    ],
    madeWith: ['reactjs', 'javascript', 'sass'],
  },
  {
    title: 'Looper App',
    folder: 'looper',
    genre: 'audio',
    urlLive: 'https://onchetrit.github.io/looper-app/',
    urlGithub: 'https://github.com/OnChetrit/looper-app',
    mobile_image: './projects/looper/mobile.jpeg',
    desktop_image: './projects/looper/desk.jpeg',
    desc: [
      'This project use Web Audio API & Canvas API,',
      'this app allows you to play with the audio files',
      'I use web audio api so that I can play audio loops without gaps',
      'adjust volume and make audio inActive',
    ],
    madeWith: ['reactjs', 'javascript', 'sass'],
  },
  {
    title: 'Meme Generator',
    folder: 'meme-gen',
    genre: 'creative',
    urlLive: 'https://onchetrit.github.io/on-chetrit-meme-generator/',
    urlGithub: 'https://github.com/OnChetrit/on-chetrit-meme-generator',
    mobile_image: './projects/memeGenerator/mobile.jpeg',
    desktop_image: './projects/memeGenerator/desk.jpeg',
    desc: [
      'Project created with canvas',
      'Easily add captions to photos, Use your own images or access a large collection of memes.',
      'Save your meme or export to your device.',
    ],
    madeWith: ['javascript', 'html', 'css'],
  },
  {
    title: 'Touch the numbers',
    folder: 'touch-nums',
    genre: 'game',
    urlLive: 'https://onchetrit.github.io/TouchNums/',
    urlGithub: 'https://github.com/OnChetrit/TouchNums',
    mobile_image: './projects/touchNumbers/mobile.jpeg',
    desktop_image: './projects/touchNumbers/desk.jpeg',
    desc: [
      'Beat the time!',
      'Click on the numbers in ascending order according to the level and do it in the best time.',
    ],
    madeWith: ['javascript', 'html', 'css'],
  },
  {
    title: 'Minesweeper',
    folder: 'minesweeper',
    genre: 'game',
    urlLive: 'https://onchetrit.github.io/MineSweeperOnChetrit/',
    urlGithub: 'https://github.com/OnChetrit/MineSweeperOnChetrit',
    mobile_image: './projects/minesweeper/mobile.jpeg',
    desktop_image: './projects/minesweeper/desk.jpeg',
    desc: [
      'Play the classic game in multiple difficulties.',
      'How to play ? ',
      'Uncover the number board without detonating bombs',
      'Each number represents the amount of bombs his neighbors circle',
      'Features: 3 LIVES, 3 Hints that help you to find bombs',
      'Left click - cell opening.',
      'Right click - Flag / Unflag.',
      'Wheel click - Opens the surrounding cells only if the number of surrounding bombs is marked as the number on the pressed cell.',
    ],
    madeWith: ['javascript', 'html', 'css'],
  },
];
